/**
*功能名称：数据源管理
*创 建 人：whr
*日    期：2023/06/15 10:15:17
*/

import {DbCenterBaseApiV2} from "../DbCenterBaseApiV2";
import {Methods} from "@newview/infrastructure";
export class LogtargetApi extends DbCenterBaseApiV2 {
    public get ControllerName(): any {
        return 'logtarget';
    }

    /**
     * 分页查询
     * @param params
     */
    public async getEntitiesPage(params) {
        return await this.send(params, "getEntitiesPage", Methods.GET);
    }

    /**
     * 获取数据
     * @param params
     */
    public async getObjectByParams(params) {
        return await this.send(params, "getObjectByParams", Methods.GET);
    }
  
}
